export const ENROLL_NEW_USER_SUCCESS = 'ENROLL_NEW_USER_SUCCESS'
export const ENROLL_NEW_USER_ERR = 'ENROLL_NEW_USER_ERR'
export const RESET_ENROLL_NEW_USER = 'RESET_ENROLL_NEW_USER'

export const GET_COUNT_USER = 'GET_COUNT_USER'
export const GET_COUNT_USER_ERR = 'GET_COUNT_USER_ERR'

